import { cva } from 'class-variance-authority';

export const headerVariants = cva([
  'flex',
  // Areas top-align so a subtext only grows the title block, leaving the
  // leading element and actions on the first 24px row.
  'items-start',
  'gap-spacing-sys-spacing-8',
  'p-spacing-ref-default',
  'relative',
]);

export const titleBlockVariants = cva([
  'flex',
  'min-w-0',
  'flex-1',
  'flex-col',
  'gap-spacing-ref-xtiny',
]);

export const titleRowVariants = cva([
  'flex',
  'min-h-sizing-sys-size-24',
  'items-center',
  'justify-between',
  'gap-spacing-sys-spacing-8',
]);
